import React, { useEffect } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { DashboardHeader } from "./header/dashboard-header";
import { DashboardSidebar } from "./sideBar/dashboard-sidebar";
import { PromotionCenter } from "./promotionCenter";
import { CustomerCenter } from "./customerCenter";
import { AdminStrator } from "./adminstrator";
import { useGetAdminInfoMutation } from "../../../store/admin/adminstrators";
import { useAppDispatch } from "../../../store/storeHooks";
import { setAdminInfo } from "../../../store/admin/adminInfoSlice";

export const DashBoard = () => {
    const {contentsType, contentsId, adminId} = useParams()
    const dispath = useAppDispatch()
    const navigate = useNavigate()
    const location = useLocation()
    const path = location.pathname.split('/')
    const [getAdminInfoApi] = useGetAdminInfoMutation()
    const getAdmin = async(id : string) => {
        const result : any = await getAdminInfoApi({id : id})
        if(result.data.result === true){
            dispath(setAdminInfo({key : result.data.manager_uuid, name : result.data.manager_name, account : result.data.manager_login}))
        }
    }
    useEffect(()=>{
        const storeId = sessionStorage.getItem('key')
        if(storeId){
            const id = storeId; getAdmin(id)
        }else{
            navigate('/dotsAdmin')
        }
    }, [dispath])
    return(
        <>
        <div id="wrap">
            <DashboardSidebar/>
            <div className="dotsContentWrap">
                <DashboardHeader/>
                {path[2] === 'prCenter' ? <PromotionCenter/> : ''}
                {path[2] === 'customerCenter' ? <CustomerCenter/> : ''}
                {path[2] === 'setting' ? <AdminStrator/> : ''}
            </div>
        </div>
        </>
    )
}